import { createSelector } from '@reduxjs/toolkit';
import { selectEncumbranceRealtyValue } from './selectEncumbranceRealtyValue';

const OPTIONS = [
  { label: 'Неважно', value: null },
  { label: 'Не показывать', value: false },
  { label: 'Показывать только их', value: true },
];

export const selectEncumbranceRealtyFilter = createSelector(selectEncumbranceRealtyValue, value => ({
  label: 'Объекты с обременением',
  value: [value],
  options: OPTIONS,
}));
